// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC0-9L6hDOXcaX3ZRJpOc_O0K3bt33saW8',
    authDomain: 'testing-9cea1.firebaseapp.com',
    databaseURL: 'https://testing-9cea1.firebaseio.com',
    projectId: 'testing-9cea1',
    storageBucket: 'testing-9cea1.appspot.com',
    messagingSenderId: '148078061373'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
